









































































































































import { Component, Vue } from "vue-property-decorator";
import axios from "axios";
import VueAxios from "vue-axios";
import VueRouter from "vue-router";
const router = new VueRouter({
  mode: "history",
});
@Component({})
export default class App extends Vue {
  language: any = null;
  jobArray: any = [];
  jobCopyArray: any = [];
  filterText: any = null;
  filterKarrierelvel: any = "";
  filterKarrierelvelArray: any = [];
  filterTaetigkeitsbereich: any = "";
  filterTaetigkeitsbereichArray: any = [];
  htmlData: any = {
    title: "",
    image: "",
    inputPlaceholder: "",
    taetigkeitsbereichPlaceholder: "",
    karrierePlaceholder: "",
    table: {
      eins: "",
      zwei: "",
      drei: "",
      vier: "",
    },
    result: "",
    results: "",
    empty: "",
    emptyLink: "",
    emptyBtn: "",
    emptySubject: "",
  };
  loadingAnimation: any = false;

  mounted() {
    this.loadingAnimation = true;
    const el = document.getElementById("test");
    const id = el?.getAttribute("data-id") ? el.getAttribute("data-id") : "";
    this.htmlData = {
      title: el?.getAttribute("data-title")
        ? el.getAttribute("data-title")
        : "",
      image: el?.getAttribute("data-image")
        ? el.getAttribute("data-image")
        : "",
      inputPlaceholder: el?.getAttribute("data-input-placeholder")
        ? el.getAttribute("data-input-placeholder")
        : "",
      taetigkeitsbereichPlaceholder: el?.getAttribute(
        "data-taetigkeitsbereich-placeholder"
      )
        ? el.getAttribute("data-taetigkeitsbereich-placeholder")
        : "",
      karrierePlaceholder: el?.getAttribute("data-karriere-placeholder")
        ? el.getAttribute("data-karriere-placeholder")
        : "",
      table: {
        eins: el?.getAttribute("data-table-eins")
          ? el.getAttribute("data-table-eins")
          : "",
        zwei: el?.getAttribute("data-table-zwei")
          ? el.getAttribute("data-table-zwei")
          : "",
        drei: el?.getAttribute("data-table-drei")
          ? el.getAttribute("data-table-drei")
          : "",
        vier: el?.getAttribute("data-table-vier")
          ? el.getAttribute("data-table-vier")
          : "",
      },
      result: el?.getAttribute("data-result")
        ? el.getAttribute("data-result")
        : "",
      results: el?.getAttribute("data-results")
        ? el.getAttribute("data-results")
        : "",
      empty: el?.getAttribute("data-empty")
        ? el.getAttribute("data-empty")
        : "",
      emptyLink: el?.getAttribute("data-empty-link")
        ? el.getAttribute("data-empty-link")
        : "",
      emptyBtn: el?.getAttribute("data-empty-btn")
        ? el.getAttribute("data-empty-btn")
        : "",
      emptySubject: el?.getAttribute("data-empty-subject")
        ? el.getAttribute("data-empty-subject")
        : "",
    };
    if (id) {
      this.language = id;
      const data = { id: id };
      axios
        .post(
          "https://www.eurotec.team/my/ajax/controller/jobs/",
          data
        )
        .then((response: any) => {
          this.loadingAnimation = false;
          this.jobArray = response.data.statement;
          this.jobCopyArray = [...this.jobArray];
          this.addFilters();
          var sortedTaetigkeitsbereichArray =
            this.filterTaetigkeitsbereichArray.sort();
          if (sortedTaetigkeitsbereichArray)
            this.filterTaetigkeitsbereichArray = sortedTaetigkeitsbereichArray;
          var sortedKarrierelvelArray = this.filterKarrierelvelArray.sort();
          if (sortedKarrierelvelArray)
            this.filterKarrierelvelArray = sortedKarrierelvelArray;
          if (this.$route.query.text) {
            this.filterText = this.$route.query.text;
            this.changeText();
          }
          if (this.$route.query.karrierelvel) {
            this.filterKarrierelvel = this.$route.query.karrierelvel;
            this.changeKarriere();
          }
          if (this.$route.query.taetigkeitsfeld) {
            this.filterTaetigkeitsbereich = this.$route.query.taetigkeitsfeld;
            this.changeTaetigkeit();
          }
        });
    }
  }

  addFilters() {
    this.jobArray.forEach((element: any) => {
      if (
        !this.filterKarrierelvelArray.includes(
          element.stellenanzeige_karrierelevel
        )
      )
        this.filterKarrierelvelArray.push(element.stellenanzeige_karrierelevel);
      if (
        !this.filterTaetigkeitsbereichArray.includes(
          element.stellenanzeige_taetigkeitsfeld
        )
      )
        this.filterTaetigkeitsbereichArray.push(
          element.stellenanzeige_taetigkeitsfeld
        );
      if (this.filterText) this.jobCopyArray = this.filterTextFunction();
    });
  }

  changeKarriere() {
    this.jobCopyArray = [...this.jobArray];
    if (this.filterKarrierelvel)
      this.jobCopyArray = this.jobCopyArray.filter(
        (item: any) =>
          item.stellenanzeige_karrierelevel === this.filterKarrierelvel
      );
    if (this.filterTaetigkeitsbereich)
      this.jobCopyArray = this.jobCopyArray.filter(
        (item: any) =>
          item.stellenanzeige_taetigkeitsfeld === this.filterTaetigkeitsbereich
      );
    if (this.filterText) this.jobCopyArray = this.filterTextFunction();
  }

  changeTaetigkeit() {
    this.jobCopyArray = [...this.jobArray];
    if (this.filterTaetigkeitsbereich)
      this.jobCopyArray = this.jobCopyArray.filter(
        (item: any) =>
          item.stellenanzeige_taetigkeitsfeld === this.filterTaetigkeitsbereich
      );
    if (this.filterKarrierelvel)
      this.jobCopyArray = this.jobCopyArray.filter(
        (item: any) =>
          item.stellenanzeige_karrierelevel === this.filterKarrierelvel
      );
    if (this.filterText) this.jobCopyArray = this.filterTextFunction();
  }

  changeText() {
    this.jobCopyArray = [...this.jobArray];
    if (this.filterText) this.jobCopyArray = this.filterTextFunction();
    if (this.filterTaetigkeitsbereich)
      this.jobCopyArray = this.jobCopyArray.filter(
        (item: any) =>
          item.stellenanzeige_taetigkeitsfeld === this.filterTaetigkeitsbereich
      );
    if (this.filterKarrierelvel)
      this.jobCopyArray = this.jobCopyArray.filter(
        (item: any) =>
          item.stellenanzeige_karrierelevel === this.filterKarrierelvel
      );
  }

  filterTextFunction() {
    return this.jobCopyArray.filter((item: any) => {
      return (
        item.title.toLowerCase().indexOf(this.filterText.toLowerCase()) > -1
      );
    });
  }
}
